import React from 'react';
import Breadcrumbs from '../../elements/Breadcrumbs';
import { NotFoundImg, NotFoundTitle, NotServiceContainer } from './TypeOfService.style';
import calendarNotFound from '../../assets/allIcons/calendarNotFound.png';

const NotFoundService = () => {

  return (
    <>
      <Breadcrumbs pathArr={[{ label: 'Запись на прием' }, { label: 'Направление' }]} />
      <NotServiceContainer>
        <NotFoundImg src={calendarNotFound} />
        <NotFoundTitle>
          Запись по направлению не ведется
        </NotFoundTitle>
      </NotServiceContainer>
    </>
  )
}

export default NotFoundService;
